export const SUPPORT_TASK_MANAGER_COPY_FORM = 'SUPPORT_TASK_MANAGER_COPY_FORM';
export const SUPPORT_TASK_MANAGER_COPY_FORM_INIT = 'SUPPORT_TASK_MANAGER_COPY_FORM_INIT';
export const GET_DISTANCES_FOR_COPY_RACERS = 'GET_DISTANCES_FOR_COPY_RACERS';
export const SEND_COPY_RACERS = 'SEND_COPY_RACERS';
export const LOAD_ORGANIZERS = 'LOAD_ORGANIZERS';
